"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_6 = ["data-text"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-download text-green" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const vue_router_1 = require("vue-router");
const customersStore_1 = require("../../stores/customers/customersStore");
const toastStore_1 = require("../../stores/toast/toastStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminContracts',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g;
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const contractsLoading = (0, vue_3.ref)(false);
        const contracts = (0, vue_3.ref)([]);
        const totalContracts = (0, vue_3.ref)(0);
        const customerGroupOptions = (0, vue_3.computed)(() => {
            return customersStore.customerGroups.map((value) => {
                return new Option_1.default(value, value, selectedContract.value.customerGroup === value);
            });
        });
        const errorMessage = (0, vue_3.ref)("");
        const modalIsOpen = (0, vue_3.ref)(false);
        const selectedContract = (0, vue_3.ref)({
            "@id": null,
            id: null,
            contentUrl: "",
            fileName: "",
            originalFileName: "",
            fileSize: 0,
            mimeType: "",
            dimensions: null,
            fromDate: "",
            toDate: null,
            customerGroup: "",
            currencyCode: "",
            countryCode: "",
            title: "",
        });
        const selectedContractName = (0, vue_3.ref)(null);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "contracts")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "title",
                label: (_b = (0, i18n_1.trans)("title", "Title", "contracts")) !== null && _b !== void 0 ? _b : "Title",
                value: "title",
                filterable: true,
                sortable: true,
            },
            {
                key: "fromDate",
                label: (_c = (0, i18n_1.trans)("from_date", "From Date", "contracts")) !== null && _c !== void 0 ? _c : "From Date",
                value: "fromDate",
                filterable: true,
                sortable: true,
            },
            {
                key: "toDate",
                label: (_d = (0, i18n_1.trans)("to_date", "To Date", "contracts")) !== null && _d !== void 0 ? _d : "To Date",
                value: "toDate",
                filterable: true,
                sortable: true,
            },
            {
                key: "customerGroup",
                label: (_e = (0, i18n_1.trans)("customer_group", "Customer Group", "contracts")) !== null && _e !== void 0 ? _e : "Customer Group",
                value: "customerGroup",
                filterable: true,
                sortable: true,
            },
            {
                key: "currencyCode",
                label: (_f = (0, i18n_1.trans)("currency_code", "Currency Code", "contracts")) !== null && _f !== void 0 ? _f : "Currency Code",
                value: "currencyCode",
                filterable: true,
                sortable: true,
            },
            {
                key: "countryCode",
                label: (_g = (0, i18n_1.trans)("country_code", "Country Code", "contracts")) !== null && _g !== void 0 ? _g : "Country Code",
                value: "countryCode",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const uploadedFile = (0, vue_3.ref)(null);
        const selectedCustomerGroup = (0, vue_3.ref)("");
        (0, vue_3.onBeforeMount)(async () => {
            contracts.value = [];
            try {
                await customersStore.getCustomerGroups(router);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        const getContracts = async () => {
            var _a;
            contractsLoading.value = true;
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            const params = {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                order: { [sortBy.value]: sortDesc.value ? "desc" : "asc" },
                ...filters,
            };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "admin_contracts_api", query: params }).href);
                contracts.value = (response["hydra:member"] || []).filter((item) => item["@type"] === "Contract");
                totalContracts.value = (_a = response["hydra:totalItems"]) !== null && _a !== void 0 ? _a : 0;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            finally {
                contractsLoading.value = false;
            }
        };
        const addContract = () => {
            selectedContract.value = {
                "@id": null,
                id: null,
                contentUrl: "",
                fileName: "",
                originalFileName: "",
                fileSize: 0,
                mimeType: "",
                dimensions: null,
                fromDate: "",
                toDate: null,
                customerGroup: "",
                currencyCode: "",
                countryCode: "",
                title: "",
            };
            selectedCustomerGroup.value = "";
            selectedContractName.value = null;
            modalIsOpen.value = true;
        };
        const editContract = (contract) => {
            selectedContractName.value = contract.title;
            selectedContract.value = { ...contract };
            modalIsOpen.value = true;
        };
        const deleteContract = async (contract) => {
            if (!confirm((0, i18n_1.trans)("Are you sure?")))
                return;
            errorMessage.value = "";
            selectedContractName.value = contract.title;
            selectedContract.value = { ...contract };
            contractsLoading.value = true;
            try {
                await (0, fetch_1.default)(router.resolve({ name: "admin_contracts_api", params: { id: contract.id } }).href, { method: "DELETE" });
                page.value = 1;
                await getContracts();
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
            finally {
                contractsLoading.value = false;
            }
        };
        const saveContract = async () => {
            errorMessage.value = "";
            const formData = new FormData();
            if (uploadedFile.value !== null) {
                formData.append("file", uploadedFile.value);
            }
            formData.append("title", String(selectedContract.value.title));
            formData.append("fromDate", String(selectedContract.value.fromDate));
            formData.append("toDate", String(selectedContract.value.toDate));
            formData.append("customerGroup", selectedCustomerGroup.value);
            formData.append("currencyCode", String(selectedContract.value.currencyCode));
            formData.append("countryCode", String(selectedContract.value.countryCode));
            contractsLoading.value = true;
            try {
                const url = router.resolve({
                    name: "admin_contracts_api",
                    params: selectedContract.value.id ? { id: selectedContract.value.id } : {}
                }).href;
                await (0, fetch_1.default)(url, { method: "POST", body: formData });
                uploadedFile.value = null;
                modalIsOpen.value = false;
                page.value = 1;
                await getContracts();
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
            finally {
                contractsLoading.value = false;
            }
        };
        const exportAcceptedContractUsers = async (contractId) => {
            errorMessage.value = "";
            try {
                await (0, fetch_1.default)(router.resolve({
                    name: "admin_export_accepted_contract_users_api",
                    params: { id: contractId }
                }).href).then((response) => {
                    const blob = new Blob([response], { type: 'text/csv' });
                    const fileName = 'contract' + contractId + '_ac_users.csv';
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(objectUrl);
                });
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
            }
        });
        (0, vue_3.watch)([listFields.value, page, itemsPerPage, sortBy, sortDesc], () => {
            getContracts();
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (addContract()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_contract", "Add Contract", "contracts")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    items: contracts.value,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: contractsLoading.value,
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: totalContracts.value
                }, {
                    "cell-title": (0, vue_2.withCtx)(({ item: contract }) => [
                        (0, vue_2.createElementVNode)("a", {
                            href: contract.contentUrl,
                            class: "underline",
                            target: "_blank"
                        }, (0, vue_2.toDisplayString)(contract.title), 9, _hoisted_4)
                    ]),
                    "cell-fromDate": (0, vue_2.withCtx)(({ item: contract }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(contract.fromDate), 1)
                    ]),
                    "cell-toDate": (0, vue_2.withCtx)(({ item: contract }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(contract.toDate), 1)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: contract }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", {
                                class: "textbox textbox-right text-left lg:text-center coupon-state",
                                "data-text": (0, vue_2.unref)(i18n_1.trans)('export_accepted_users', 'export users', 'contracts')
                            }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-success btn-link",
                                    onClick: (0, vue_2.withModifiers)(($event) => (exportAcceptedContractUsers(contract.id)), ["prevent"])
                                }, _hoisted_9, 8, _hoisted_7)
                            ], 8, _hoisted_6),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (editContract(contract))
                            }, [
                                _hoisted_11,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "contracts")), 1)
                            ], 8, _hoisted_10),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteContract(contract))
                            }, [
                                _hoisted_13,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "contracts")), 1)
                            ], 8, _hoisted_12)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: selectedContractName.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_contract_modal_title', 'Edit Contract: {group}', 'contracts', { group: selectedContractName.value })
                        : (0, vue_2.unref)(i18n_1.trans)('add_contract_modal', 'Add Contract', 'contracts'),
                    onClose: _cache[14] || (_cache[14] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error_alert_title', 'Save error', 'contracts'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_title_placeholder', 'Contract Title', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_title_label', 'Contract Title', 'contracts'),
                            required: "",
                            modelValue: selectedContract.value.title,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedContract.value.title) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_from_date_placeholder', 'Contract From Date', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_from_date_label', 'Contract From Date', 'contracts'),
                            type: "date",
                            required: "",
                            modelValue: selectedContract.value.fromDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedContract.value.fromDate) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_to_date_placeholder', 'Contract To Date', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_to_date_label', 'Contract To Date', 'contracts'),
                            type: "date",
                            required: "",
                            modelValue: selectedContract.value.toDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedContract.value.toDate) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                            modelValue: selectedCustomerGroup.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((selectedCustomerGroup).value = $event)),
                            class: "mb-5",
                            "placeholder-enable": true,
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_customer_group', 'Contract Customer Group', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_customer_group', 'Contract Customer Group', 'contracts'),
                            options: (0, vue_2.unref)(customerGroupOptions)
                        }, null, 8, ["modelValue", "placeholder", "label", "options"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_currency_code_placeholder', 'Contract Currency Code', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_currency_code_label', 'Contract Currency Code', 'contracts'),
                            "max-length": 3,
                            required: "",
                            modelValue: selectedContract.value.currencyCode,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedContract.value.currencyCode) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('contract_country_code_placeholder', 'Contract Country Code', 'contracts'),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_country_code_label', 'Contract Country Code', 'contracts'),
                            "max-length": 2,
                            required: "",
                            modelValue: selectedContract.value.countryCode,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedContract.value.countryCode) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInput), {
                            modelValue: uploadedFile.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((uploadedFile).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('contract_file', 'Contract File', 'contracts')
                        }, null, 8, ["modelValue", "label"]),
                        (selectedContract.value.id !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                key: 1,
                                href: selectedContract.value.contentUrl,
                                class: "underline",
                                target: "_blank"
                            }, (0, vue_2.toDisplayString)(selectedContract.value.fileName), 9, _hoisted_14))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary",
                                onClick: _cache[13] || (_cache[13] = ($event) => (saveContract()))
                            }, [
                                _hoisted_16,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "contracts")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
